import { isEmpty } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { tLead } from '../../../providers/SocketsProvider/Sockets.types';
import { useWorkspaceContext } from '../../../providers/WorkspaceProvider/Workspace.context';
import { eAgendaTabs } from '../Agenda.enums';
import { templateLegacyParser } from '../Agenda.functions';
import { AgendaService } from '../Agenda.service';
import {
  tAgendaContext,
  tAgendaEvent,
  tEventType,
  tTemplate,
} from '../Agenda.types';
import { AgendaContext } from '../providers/agenda.context';

export function useAgendaContext(): tAgendaContext {
  return useContext(AgendaContext);
}

export default function useAgenda(): tAgendaContext {
  const { currentWorkspace } = useWorkspaceContext();

  const [currentTab, setCurrentTab] = useState<eAgendaTabs>(eAgendaTabs.EVENTS);
  const [currentTemplates, setCurrentTemplates] = useState<tTemplate[] | null>(
    null,
  );
  const [currentEventTypes, setCurrentEventTypes] = useState<Record<
    string,
    tEventType
  > | null>(null);
  const [currentEvents, setCurrentEvents] = useState<tAgendaEvent[] | null>(
    null,
  );
  const [selectedLead, setSelectedLead] = useState<tLead | null>(null);

  useEffect(() => {
    if (isEmpty(currentWorkspace?.id) || currentTab === eAgendaTabs.TEMPLATES) {
      return;
    }

    (() => {
      const response = AgendaService.getEventTypes();

      if (!isEmpty(response) && response) {
        setCurrentEventTypes({
          [response[0].id]: {
            id: 'EVENT_TYPE_CALL',
            color: 'border-purple-950',
            name: 'Llamada',
          },
          [response[1].id]: {
            id: 'EVENT_TYPE_MEETING',
            color: 'border-yellow-300',
            name: 'Reunión',
          },
          [response[2].id]: {
            id: 'EVENT_TYPE_TASK',
            color: 'border-green-crayola',
            name: 'Tarea',
          },
        });
      }
    })();

    (async () => {
      if (!currentWorkspace) return;

      const response = await AgendaService.getCurrentTemplates(
        currentWorkspace.id,
      );

      if (response) {
        setCurrentTemplates(
          response.data.templates.map((template) =>
            templateLegacyParser(template, currentWorkspace.id),
          ),
        );
      }
    })();
  }, [currentTab, currentWorkspace?.id]);

  function getCurrentEvent(id: string): tAgendaEvent | undefined {
    return currentEvents?.find((event) => event.id === id);
  }

  function getCurrentEventType(id: string): tEventType | undefined {
    const template = currentTemplates?.find((template) => template.id === id);
    return currentEventTypes?.[template?.event_type ?? ''];
  }

  async function deleteTemplate(template: tTemplate): Promise<void> {
    if (!currentTemplates) return;

    await AgendaService.deleteCalendarTemplate(template.id);
    setCurrentTemplates(currentTemplates.filter((t) => t.id !== template.id));
  }

  return {
    setCurrentTab,
    currentTab,
    currentTemplates,
    deleteTemplate,
    setCurrentTemplates,
    currentEventTypes,
    currentEvents,
    setCurrentEvents,
    getCurrentEvent,
    getCurrentEventType,
    selectedLead,
    setSelectedLead,
  };
}
